import React, { useState } from 'react';
import { PageHeader } from '../../components/ui/PageHeader';
import { Panel } from '../../components/ui/Panel';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Meter } from '../../components/ui/Meter';
import { Tabs } from '../../components/ui/Tabs';
import { DataTable } from '../../components/ui/DataTable';
import { auditLog, moderationQueue, platformMetrics, reportedAccounts, supplyDemand, verificationQueue } from '../../data/admin';
import { institutions } from '../../data/institutions';
import { percent } from '../../utils/format';
const TABS = ['Operations', 'Moderation', 'Verification', 'Platform'] as const;
export function PlatformOverview() {
  const [tab, setTab] = useState<(typeof TABS)[number]>('Operations');
  return <div className="space-y-6" data-id="element-6642" data-mp="3pa593ukp54ce">
      <PageHeader eyebrow="Campuzon administration" title="Platform operations" description="Operational administration, moderation, verification and sensitive-data access are deliberately separated. Every action is attributed and logged." data-id="element-6643" data-mp="3p9dh0tqb5oqv" />

      <Tabs tabs={TABS} value={tab} onChange={setTab} label="Admin sections" data-id="element-6644" data-mp="34b0sp6n8habv" />

      {tab === 'Operations' && <div className="space-y-6" data-id="element-6645" data-mp="3943mnfvxalsl">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-6646" data-mp="3e257a58zyt66">
            {platformMetrics.map(metric => <Panel key={metric.label} data-id="element-6647" data-mp="2gfg1dkb6bwf1">
                <p className="cz-num text-2xl font-semibold tracking-tight text-ink" data-id="element-6648" data-mp="2gghdls3xeoyc">
                  {metric.value}
                </p>
                <p className="mt-1 text-[13px] text-ink-muted" data-id="element-6649" data-mp="2qd3xadkin9ys">{metric.label}</p>
                <p className="cz-num mt-1 text-[12px] text-ink-subtle" data-id="element-6650" data-mp="2vbx981k5mswu">{metric.delta}</p>
              </Panel>)}
          </div>

          <div className="grid gap-6 lg:grid-cols-2" data-id="element-6651" data-mp="5ljv6fl2jjyu">
            <Panel title="Housing supply and demand" description="Aggregated market view — never individual students." bodyClassName="p-0" data-id="element-6652" data-mp="5oy11xsxybb1">
              <ul className="divide-y divide-line" data-id="element-6653" data-mp="26qnrj9jkh57x">
                {supplyDemand.map(row => <li key={row.city} className="flex items-center gap-4 px-5 py-3.5" data-id="element-6654" data-mp="21s3zqsiakz7n">
                    <p className="w-24 shrink-0 text-[13px] font-medium text-ink" data-id="element-6655" data-mp="2fneso0cz7a9d">{row.city}</p>
                    <div className="min-w-0 flex-1" data-id="element-6656" data-mp="2blt9xydrg1r9">
                      <Meter value={percent(row.supply, row.demand)} label="Supply against demand" trailing={`${percent(row.supply, row.demand)}%`} tone={row.supply / row.demand < 0.6 ? 'warn' : 'brand'} data-id="element-6657" data-mp="1nxjv5geyse9m" />
                    </div>
                    <p className="cz-num w-24 text-right text-[13px] text-ink-muted" data-id="element-6658" data-mp="1rxtyelbdgqks">
                      {row.listings} listings
                    </p>
                  </li>)}
              </ul>
            </Panel>

            <Panel title="Institutions" bodyClassName="p-0" data-id="element-6659" data-mp="q4aeod9x414v">
              <ul className="divide-y divide-line" data-id="element-6660" data-mp="q2qysns6bs3m">
                {institutions.map(institution => <li key={institution.id} className="flex items-center gap-3 px-5 py-3.5" data-id="element-6661" data-mp="uxdbqvdwlspt">
                    <div className="min-w-0 flex-1" data-id="element-6662" data-mp="g4jlcex3fs6d">
                      <p className="text-[13px] font-medium text-ink" data-id="element-6663" data-mp="l6sfvfpm72al">{institution.name}</p>
                      <p className="text-[12px] text-ink-muted" data-id="element-6664" data-mp="18v1x04bvv1ve">
                        {institution.place.city}, {institution.place.state} ·{' '}
                        {institution.campuses.length} campus(es)
                      </p>
                    </div>
                    <Badge tone={institution.integrationLevel === 'full' ? 'ok' : institution.integrationLevel === 'directory' ? 'brand' : 'neutral'} data-id="element-6665" data-mp="13w8gs457owrj">
                      {institution.integrationLevel === 'none' ? 'No integration' : institution.integrationLevel === 'directory' ? 'Directory sync' : 'Full integration'}
                    </Badge>
                  </li>)}
              </ul>
            </Panel>
          </div>
        </div>}

      {tab === 'Moderation' && <div className="grid gap-6 lg:grid-cols-3" data-id="element-6666" data-mp="rkpun4hbfaoh">
          <Panel className="lg:col-span-2" title="Moderation queue" bodyClassName="p-0" data-id="element-6667" data-mp="mpaj4j6s5qv8">
            <ul className="divide-y divide-line" data-id="element-6668" data-mp="hnuygs8ilmdd">
              {moderationQueue.map(item => <li key={item.id} className="px-5 py-4" data-id="element-6669" data-mp="cors94gsta3t">
                  <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-6670" data-mp="32f3rmqbbd957">
                    <div className="min-w-0" data-id="element-6671" data-mp="32d0uznfnohri">
                      <p className="text-[13px] font-semibold text-ink" data-id="element-6672" data-mp="2xfr403cmby1k">{item.subject}</p>
                      <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-6673" data-mp="1cyhx2ijvl0j6">{item.reason}</p>
                      <p className="cz-num mt-0.5 text-[12px] text-ink-subtle" data-id="element-6674" data-mp="1hwt82wlwph2z">
                        {item.surface} · {item.reports} report(s) · {item.raised}
                      </p>
                    </div>
                    <div className="flex shrink-0 items-center gap-2" data-id="element-6675" data-mp="1rn5s8npt788l">
                      <Badge tone={item.severity === 'High' ? 'danger' : item.severity === 'Medium' ? 'warn' : 'neutral'} data-id="element-6676" data-mp="1wlz5cf16ox88">
                        {item.severity}
                      </Badge>
                      <Button size="sm" variant="secondary" data-id="element-6677" data-mp="b8w1xo20b9f4">
                        Review
                      </Button>
                    </div>
                  </div>
                </li>)}
            </ul>
          </Panel>
          <Panel title="Reported accounts" bodyClassName="p-0" data-id="element-6678" data-mp="87sza04jujxu">
            <ul className="divide-y divide-line" data-id="element-6679" data-mp="45xxyvmmc6k2">
              {reportedAccounts.map(item => <li key={item.id} className="flex items-center gap-3 px-5 py-3.5" data-id="element-6680" data-mp="i5qlki2um6nt">
                  <div className="min-w-0 flex-1" data-id="element-6681" data-mp="d648q9qxmsfj">
                    <p className="text-[13px] font-medium text-ink" data-id="element-6682" data-mp="d4jcmfoyz1fk">{item.account}</p>
                    <p className="cz-num text-[12px] text-ink-muted" data-id="element-6683" data-mp="r4u6lrlksw4y">
                      {item.role} · {item.reports} reports
                    </p>
                  </div>
                  <Badge tone={item.state === 'Restricted' ? 'danger' : 'warn'} data-id="element-6684" data-mp="10w89888tqc2b">{item.state}</Badge>
                </li>)}
            </ul>
          </Panel>
        </div>}

      {tab === 'Verification' && <Panel title="Verification queue" description="Properties, owners, employers and institutions awaiting checks. Approval states exactly what was verified — never that a property was inspected." bodyClassName="p-0" data-id="element-6685" data-mp="1auo2agrevveg">
          <ul className="divide-y divide-line" data-id="element-6686" data-mp="1thwvtdaxww2r">
            {verificationQueue.map(task => <li key={task.id} className="flex flex-wrap items-center gap-3 px-5 py-3.5" data-id="element-6687" data-mp="1finrpc00dsf5">
                <div className="min-w-0 flex-1" data-id="element-6688" data-mp="1khi8k8ef16wm">
                  <p className="text-[13px] font-semibold text-ink" data-id="element-6689" data-mp="1kg79glvx0nbu">{task.subject}</p>
                  <p className="cz-num mt-0.5 text-[12px] text-ink-muted" data-id="element-6690" data-mp="15rjdiei5qbld">
                    {task.type} · submitted by {task.submittedBy} on {task.submitted}
                  </p>
                </div>
                <Badge tone={task.status === 'Approved' ? 'ok' : task.status === 'Escalated' ? 'danger' : 'warn'} data-id="element-6691" data-mp="wt7f3qb1u9id">
                  {task.status}
                </Badge>
                {task.status !== 'Approved' && <Button size="sm" variant="secondary" data-id="element-6692" data-mp="179t5fuium2wx">
                    Open
                  </Button>}
              </li>)}
          </ul>
        </Panel>}

      {tab === 'Platform' && <Panel title="Audit log" description="Attributed record of administrative, moderation, verification and sensitive-data activity." bodyClassName="p-0" data-id="element-6693" data-mp="y8la9lbmpi72">
          <DataTable caption="Attributed administrative audit log" rowKey={entry => entry.id} rows={auditLog} columns={[{
        header: 'Actor',
        primary: true,
        cell: entry => entry.actor
      }, {
        header: 'Role',
        cell: entry => entry.actorRole
      }, {
        header: 'Action',
        cell: entry => entry.action
      }, {
        header: 'Target',
        cell: entry => entry.target
      }, {
        header: 'Scope',
        status: true,
        cell: entry => <Badge tone={entry.scope === 'Sensitive data' ? 'danger' : 'neutral'} data-id="element-6695" data-mp="3mmtmf0b5x50c">
                    {entry.scope}
                  </Badge>
      }, {
        header: 'Time',
        cell: entry => <span className="cz-num" data-id="element-6696" data-mp="esmrwih0132">{entry.time}</span>
      }]} data-id="element-6694" data-mp="odjliql9mi50" />
        </Panel>}
    </div>;
}